module.exports = __webpack_public_path__ + "img/1541366566.6c08d65b.jpg";